// Calculate volume in cubic meters
export const calculateVolume = (
  length: number,
  width: number,
  height: number,
): number => {
  // Convert from cm to m
  const lengthInM = length / 100
  const widthInM = width / 100
  const heightInM = height / 100
  return lengthInM * widthInM * heightInM
}
// Estimate distance between two Estonian addresses
// This is a simplified version - in a real app, you'd use a geocoding API
export const estimateDistance = (
  pickupCity: string,
  deliveryCity: string,
): number => {
  const cities: Record<string, { lat: number; lng: number }> = {
    tallinn: { lat: 59.437, lng: 24.745 },
    tartu: { lat: 58.378, lng: 26.729 },
    pärnu: { lat: 58.385, lng: 24.496 },
    narva: { lat: 59.379, lng: 28.191 },
    'kohtla-järve': { lat: 59.397, lng: 27.273 },
    viljandi: { lat: 58.364, lng: 25.594 },
    rakvere: { lat: 59.346, lng: 26.352 },
    maardu: { lat: 59.466, lng: 24.982 },
    kuressaare: { lat: 58.255, lng: 22.487 },
    sillamäe: { lat: 59.397, lng: 27.765 },
    valga: { lat: 57.777, lng: 26.032 },
    võru: { lat: 57.844, lng: 27.019 },
    jõhvi: { lat: 59.357, lng: 27.421 },
    haapsalu: { lat: 58.943, lng: 23.541 },
    keila: { lat: 59.305, lng: 24.414 },
  }
  // Default to a minimum distance if cities aren't found
  const defaultDistance = 20
  const pickup = pickupCity.toLowerCase()
  const delivery = deliveryCity.toLowerCase()
  // If both cities are found in our database
  if (cities[pickup] && cities[delivery]) {
    const pickupCoords = cities[pickup]
    const deliveryCoords = cities[delivery]
    // Calculate distance using Haversine formula
    const R = 6371 // Earth's radius in km
    const dLat = ((deliveryCoords.lat - pickupCoords.lat) * Math.PI) / 180
    const dLon = ((deliveryCoords.lng - pickupCoords.lng) * Math.PI) / 180
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((pickupCoords.lat * Math.PI) / 180) *
        Math.cos((deliveryCoords.lat * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distance = R * c
    return Math.round(distance)
  }
  // If cities aren't found, return default
  return defaultDistance
}
// Calculate price based on volume, distance, and extras
export const calculatePrice = (
  volume: number,
  distance: number,
  vehicleSize: string,
  numberOfMovers: number,
  packingService: boolean,
  insurance: boolean,
): number => {
  // Base pricing
  const volumePrice = volume * 50 // €50 per cubic meter
  const distancePrice = distance * 1.2 // €1.2 per kilometer
  // Extra fees
  const vehicleSizeFee =
    vehicleSize === 'large' ? 50 : vehicleSize === 'medium' ? 25 : 0
  const moversFee = numberOfMovers > 1 ? (numberOfMovers - 1) * 35 : 0 // €35 per additional mover
  const packingFee = packingService ? volume * 15 : 0 // €15 per cubic meter for packing
  const insuranceFee = insurance ? volume * 5 : 0 // €5 per cubic meter for insurance
  // Calculate total
  const total =
    volumePrice +
    distancePrice +
    vehicleSizeFee +
    moversFee +
    packingFee +
    insuranceFee
  // Round to nearest euro
  return Math.round(total)
}
